import axios from "../../axios"
import {
  Roles,
  studyHallCourseNamesByProgram
} from "../../../mp-utils/generic-utils"
import { db } from "../../../mp-database/firebaseConfig"
import { getCourseByName } from "../../../mp-client/Courses"
import { getSubcourses } from "../../../mp-client/SubCourses"
import { getLessonBySubCourseId } from "../../../mp-client/Lessons"
import addExtraData from "../../helpers/assessment/assessmentDashboard/addExtraData"
import getAutoTutorRecommendations from "../../helpers/assessment/getAutoTutorRecommendations"
import { cloneDeep } from "lodash"
import { getSchoolYear } from "../../../mp-utils/generic-utils"

export const STUDY_HALL_MODIFY = "STUDY_HALL_MODIFY"

const filterStudentsByRole = (user, students) => {
  if (user.role === Roles.Teacher) {
    students = students.filter(s => s.teachers && s.teachers[user.id])
  }
  return students
}

export const grabMostRecentPracticeTest = (
  student,
  testCategory,
  assessmentSets
) => {
  return async (dispatch, getState) => {
    if (!assessmentSets) return

    try {
      const { id } = student

      const grabUpdatedStudent = await db
        .collection("students")
        .doc(id)
        .get()
        .then(studentDoc => studentDoc.data())

      const grabNodes = await db
        .collection("knowledgeMapNodes")
        .get()
        .then(querySnapshot => {
          let fetchedNodes = {}
          querySnapshot.forEach(doc => {
            const data = doc.data()
            if (!data.deleted) {
              fetchedNodes[data.id] = data
            }
          })
          return fetchedNodes
        })
      if (
        grabUpdatedStudent?.activity &&
        Object.keys(grabUpdatedStudent?.activity).length
      ) {
        const { activity } = grabUpdatedStudent
        const { testComplete } = activity

        if (testComplete && Object.keys(testComplete).length) {
          let recentCompletedSubtestId = ""
          const completedSubtestIds = Object.keys(testComplete).filter(
            subtestId => {
              //filter out subtests based on testCategory param
              for (let assessmentId in assessmentSets) {
                if (
                  assessmentSets[assessmentId] &&
                  assessmentSets[assessmentId]?.assessmentSubtests[subtestId]
                ) {
                  let tCategory = "ACT"

                  if (
                    assessmentSets[assessmentId]?.assessmentSubtests[subtestId]
                      .testCategory
                  ) {
                    tCategory =
                      assessmentSets[assessmentId]?.assessmentSubtests[
                        subtestId
                      ].testCategory
                  }

                  if (tCategory.toLowerCase().includes(testCategory)) {
                    return true
                  }
                }
              }
            }
          )

          const timeStamps = completedSubtestIds.map(
            subtestId => testComplete[subtestId]
          )
          const timeStamp = Math.max(...timeStamps)

          completedSubtestIds.forEach(subtestId => {
            if (testComplete[subtestId] === timeStamp) {
              recentCompletedSubtestId = subtestId
            }
          })

          if (recentCompletedSubtestId) {
            dispatch(
              setStudyHallData({
                fetchRecentActPracticeTest: true
              })
            )

            let grabUserAssessment = await db
              .collection("userAssessments")
              .where(
                `scoring.bySubtest.${recentCompletedSubtestId}.complete`,
                "==",
                true
              )
              .where("userId", "==", id)
              .get()
              .then(userAssessmentDoc => {
                if (!userAssessmentDoc.empty) {
                  let uA
                  userAssessmentDoc.forEach(doc => {
                    const uADoc = doc.data()

                    if (!uADoc.deleted) {
                      uA = uADoc
                    }
                  })
                  return uA
                }
              })

            if (grabUserAssessment) {
              grabUserAssessment = await addExtraData(grabUserAssessment)

              const {
                assessmentSet,
                assessmentSubtests,
                scoring,
                assessmentSetId,
                userAssessmentId,
                year
              } = grabUserAssessment
              const { bySubtest, byNode, byItem } = scoring

              if (bySubtest) {
                const recommendations = {}
                const bySubtestProficiency = {}

                for (let subtestId in bySubtest) {
                  if (bySubtest[subtestId].complete) {
                    const { displayName } = assessmentSubtests[subtestId]

                    recommendations[displayName] = {}
                    bySubtestProficiency[displayName] = {}

                    const dataObj = {
                      testType: assessmentSet.type || "ACT",
                      byNode: byNode[subtestId],
                      bySubtest: bySubtest[subtestId],
                      subject: displayName,
                      nodes: grabNodes,
                      grabAllSkills: true
                    }

                    let recommendationsBySubtest = getAutoTutorRecommendations(
                      dataObj,
                      true,
                      false
                    )

                    if (
                      recommendationsBySubtest &&
                      recommendationsBySubtest.length
                    ) {
                      recommendationsBySubtest.forEach(recommendation => {
                        recommendations[displayName] = {
                          ...recommendations[displayName],
                          [recommendation.nodeId]: recommendation
                        }
                      })
                    }

                    const nodesBySubtest = byNode[subtestId]

                    for (let nodeId in nodesBySubtest) {
                      if (nodesBySubtest?.[nodeId] && grabNodes?.[nodeId]) {
                        const { items = [] } = nodesBySubtest[nodeId]
                        const { name = "" } = grabNodes[nodeId]

                        if (!bySubtestProficiency[displayName][nodeId]) {
                          bySubtestProficiency[displayName][nodeId] = {}
                        }
                        const itemsCopy = items?.slice()?.map(itemId => {
                          let itm = byItem[subtestId][itemId]
                          let prefix = ""

                          if (displayName.includes("Math - Calc")) {
                            prefix = "C"
                          }
                          if (displayName.includes("Math - No Calc")) {
                            prefix = "N"
                          }
                          return (itm = {
                            ...itm,
                            prefix,
                            subtestId,
                            assessmentSetId,
                            userAssessmentId,
                            year
                          })
                        })
                        bySubtestProficiency[displayName][nodeId] = {
                          ...nodesBySubtest[nodeId],
                          items: itemsCopy || [],
                          name,
                          testName: assessmentSet.displayName,
                          subtestId,
                          assessmentSetId,
                          userAssessmentId,
                          year
                        }
                      }
                    }
                  }
                }
                dispatch(
                  setStudyHallData({
                    fetchRecentActPracticeTest: false,
                    recommendations,
                    bySubtestProficiency,
                    recentActPracticeTest: grabUserAssessment
                  })
                )
              }
            }
          }
        }
      }
    } catch (error) {
      console.log(error)

      dispatch(
        setStudyHallData({
          fetchRecentActPracticeTest: false,
          fetchRecentActPracticeTestFailed: error
        })
      )
    }
  }
}

export const fetchStudentsBySchoolId = school_id => {
  return (dispatch, getState) => {
    const user = getState().users.testUser
    dispatch(
      setStudyHallData({
        isStudentsFetched: false
      })
    )
    db.collection("students")
      .where(`school`, "==", school_id)
      .get()
      .then(sn => {
        let students = []
        sn.forEach(sdata => {
          let data = sdata.data()
          if (data && !data.deleted) {
            students.push(data)
          }
        })
        dispatch(
          setStudyHallData({
            isStudentsFetched: true,
            students: filterStudentsByRole(user, students)
          })
        )
      })
  }
}

export const fetchStudentsByDistrictId = district_id => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        isStudentsFetched: false
      })
    )
    db.collection("students")
      .where(`schoolDistrict`, "==", district_id)
      .get()
      .then(sn => {
        let students = []
        sn.forEach(sdata => {
          let data = sdata.data()
          if (data && !data.deleted) {
            students.push(data)
          }
        })
        dispatch(
          setStudyHallData({
            isStudentsFetched: true,
            students
          })
        )
      })
  }
}

export const fetchCourseData = license => {
  return dispatch => {
    if (!license) return

    // Always clear state first, regardless of program support
    dispatch(
      setStudyHallData({
        isFetchedCourse: false,
        isFetchedSubCourses: false,
        subCourses: [],
        lessons: [],
        course: {},
        currentProgram: license.toLowerCase(),
        videoStats: {}
      })
    )

    const courseName = studyHallCourseNamesByProgram[license]

    if (!courseName) {
      console.warn(
        "Unable to fetch study hall course data. Study Hall program code not found within the list:",
        { studyHallCourseNamesByProgram, license }
      )
      // State is already cleared, so old data won't persist
      return
    }
    getCourseByName(courseName).then(data => {
      return dispatch(
        setStudyHallData({
          course: data,
          isFetchedCourse: true
        })
      )
    })
  }
}

export const fetchSubCourses = courseId => {
  return dispatch => {
    if (courseId) {
      dispatch(
        setStudyHallData({
          isFetchedSubCourses: false,
          isFetchingSubCourses: true,
          lessons: []
        })
      )
      getSubcourses(courseId).then(data => {
        return dispatch(
          setStudyHallData({
            subCourses: data,
            isFetchedSubCourses: true,
            isFetchingSubCourses: false
          })
        )
      })
    }
  }
}

export const fetchLesssons = subCourseId => {
  return async dispatch => {
    dispatch(
      setStudyHallData({
        isLessonsFetched: false,
        isFetchedAllItemBanks: false
      })
    )

    await getLessonBySubCourseId(subCourseId).then(lessons => {
      return dispatch(
        setStudyHallData({
          lessons: lessons,
          isLessonsFetched: true
        })
      )
    })

    db.collection("itemBanks")
      .where("subcourseId", "==", subCourseId)
      .get()
      .then(sn => {
        let payload = {}
        sn.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            if (!data.deleted) {
              payload[doc.id] = data.items
            }
          }
        })
        return dispatch(
          setStudyHallData({
            allLessonsItemBanks: payload,
            isFetchedAllItemBanks: true
          })
        )
      })
  }
}
export const fetchAllItemBankLesssons = subCourseIds => {
  return async dispatch => {
    dispatch(
      setStudyHallData({
        isFetchedAllItemBanks: false
      })
    )
    db.collection("itemBanks")
      .where("subcourseId", "in", subCourseIds)
      .get()
      .then(sn => {
        let payload = {}
        sn.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            if (!data.deleted) {
              payload[doc.id] = data.items
            }
          }
        })
        return dispatch(
          setStudyHallData({
            allLessonsItemBanks: payload,
            isFetchedAllItemBanks: true
          })
        )
      })
  }
}

export const fetchLessonsActivities = (
  school_year,
  student_id,
  lesson_id,
  sub_course_id,
  course_id,
  district_id,
  school_id,
  teacher_id,
  class_id
) => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        isLessonActivitiesFetched: false
      })
    )
    let params = {}
    if (school_year) params.school_year = school_year
    if (student_id) params.student_id = student_id
    if (lesson_id) params.lesson_id = lesson_id
    if (sub_course_id) params.sub_course_id = sub_course_id
    if (course_id) params.course_id = course_id
    if (district_id) params.district_id = district_id
    if (school_id) params.school_id = school_id
    if (teacher_id) params.teacher_id = teacher_id
    if (class_id) params.class_id = class_id

    if (!Object.keys(params).filter(key => key !== "sub_course_id").length) {
      dispatch(
        setStudyHallData({
          practices: [],
          isPracticesFetched: true,
          isPracticesFetching: false
        })
      )
    } else {
      axios
        .get(`/study-hall/lessons_activity/filters`, {
          params
        })
        .then(res => {
          dispatch(
            setStudyHallData({
              lessonsActivity: res.data,
              isLessonActivitiesFetched: true
            })
          )
        })
    }
  }
}

export const fetchPracticeData = (
  school_year,
  student_id,
  lesson_id,
  sub_course_id,
  course_id,
  district_id,
  school_id,
  teacher_id,
  class_id
) => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        isPracticesFetched: false,
        isPracticesFetching: true
      })
    )
    let params = {}
    if (school_year) params.school_year = school_year
    if (student_id) params.student_id = student_id
    if (lesson_id) params.lesson_id = lesson_id
    if (sub_course_id) params.sub_course_id = sub_course_id
    if (course_id) params.course_id = course_id
    if (district_id) params.district_id = district_id
    if (school_id) params.school_id = school_id
    if (teacher_id) params.teacher_id = teacher_id
    if (class_id) params.class_id = class_id

    if (!Object.keys(params).filter(key => key !== "sub_course_id").length) {
      dispatch(
        setStudyHallData({
          practices: [],
          isPracticesFetched: true,
          isPracticesFetching: false
        })
      )
    } else {
      axios
        .get(`/study-hall/practice/filters`, {
          params
        })
        .then(res => {
          dispatch(
            setStudyHallData({
              practices: Array.isArray(res.data) ? res.data : [],
              isPracticesFetched: true,
              isPracticesFetching: false
            })
          )
        })
        .catch(err => {
          dispatch(
            setStudyHallData({
              practices: [],
              isPracticesFetched: false,
              isPracticesFetching: false,
              error: err.message
            })
          )
        })
    }
  }
}

export const deleteAllLessonActivity = studentsLessons => {
  return async (dispatch, getState) => {
    let activities = cloneDeep(getState().studyHall.lessonsActivity)

    const studentsActivitiesByLesson = activities.filter(activity =>
      studentsLessons.find(
        ({ lessonId, studentId }) =>
          activity.student_id === studentId && activity.lesson_id === lessonId
      )
    )

    try {
      dispatch(
        setStudyHallData({
          isLessonActivitiesUpdating: true,
          onUpdateActivityErrorMessage: ""
        })
      )

      const deletionResult = await Promise.all(
        studentsActivitiesByLesson.map(activity =>
          axios.delete(`/study-hall/lessons_activity/${activity.id}`)
        )
      )

      deletionResult.forEach(res => {
        activities = [...activities]
        activities = activities.filter(item => {
          return item.id != res.data.sid
        })
      })

      dispatch(
        setStudyHallData({
          lessonsActivity: activities,
          isLessonActivitiesUpdating: false,
          onUpdateActivityErrorMessage: ""
        })
      )
    } catch (error) {
      dispatch(
        setStudyHallData({
          lessonsActivity: activities,
          isLessonActivitiesUpdating: false,
          onUpdateActivityErrorMessage: error.message
        })
      )
      return false
    }
    return true
  }
}

export const deleteLessonActivity = (studentId, lessonId) => {
  return async (dispatch, getState) => {
    let activities = cloneDeep(getState().studyHall.lessonsActivity)
    const studentActivitiesByLesson = activities.filter(
      activity =>
        activity.student_id === studentId && activity.lesson_id === lessonId
    )

    try {
      dispatch(
        setStudyHallData({
          selectedLessonId: lessonId,
          isLessonActivitiesUpdating: true,
          onUpdateActivityErrorMessage: ""
        })
      )

      for (let i = 0; i < studentActivitiesByLesson.length; i++) {
        const activity = studentActivitiesByLesson[i]

        await axios
          .delete(`/study-hall/lessons_activity/${activity.id}`)
          .then(res => {
            activities = [...activities]
            activities = activities.filter(item => {
              return item.id != res.data.sid
            })
          })
      }

      dispatch(
        setStudyHallData({
          lessonsActivity: activities,
          selectedLessonId: lessonId,
          isLessonActivitiesUpdating: false,
          onUpdateActivityErrorMessage: ""
        })
      )
    } catch (error) {
      console.log(error)
      dispatch(
        setStudyHallData({
          lessonsActivity: activities,
          selectedLessonId: lessonId,
          isLessonActivitiesUpdating: false,
          onUpdateActivityErrorMessage: error.message
        })
      )
      return false
    }
    return true
  }
}

export const updateLessonActivity = updatedParams => {
  return async (dispatch, getState) => {
    let params = {
      district_id: "",
      school_id: "",
      course_id: "",
      sub_course_id: "",
      lesson_id: "",
      student_id: "",
      teachers: [],
      classes: [],
      watched_percentage: 0,
      play_time: 0,
      is_watched_complete: 0,
      proficiency: 0,
      practice_percentage: 0,
      practice_completed: 0,
      is_practice_resume: 0,
      is_practice_started: 0,
      practice_start_time: 0,
      practice_time_left: 0,
      school_year: Number(getSchoolYear().year)
    }
    let activities = cloneDeep(getState().studyHall.lessonsActivity)

    const activity =
      activities.find(
        currentActivity => currentActivity.lesson_id === updatedParams.lesson_id
      ) || {}

    params = Object.assign({}, params, { ...activity, ...updatedParams })

    dispatch(
      setStudyHallData({
        isLessonActivitiesUpdating: true,
        selectedLessonId: params.lesson_id,
        onUpdateActivityErrorMessage: ""
      })
    )

    return axios
      .patch("/study-hall/lessons_activity", params)
      .then(res => {
        let isUpdated = false
        activities.forEach((item, idx) => {
          if (item.lesson_id === params.lesson_id) {
            activities[idx] = res.data
            isUpdated = true
          }
        })
        if (!isUpdated) {
          activities.push(res.data)
        }
        dispatch(
          setStudyHallData({
            selectedLessonId: params.lesson_id,
            lessonsActivity: activities,
            isLessonActivitiesUpdating: false,
            onUpdateActivityErrorMessage: ""
          })
        )
        return true
      })
      .catch(error => {
        console.log({ error })
        dispatch(
          setStudyHallData({
            isLessonActivitiesUpdating: false,
            selectedLessonId: params.lesson_id,
            onUpdateActivityErrorMessage: error.message
          })
        )
        return false
      })
  }
}
export const deletePractice = id => {
  return (dispatch, getState) => {
    let practices = getState().studyHall.practices

    axios.delete(`/study-hall/practice/${id}`).then(res => {
      practices = [...practices]
      practices = practices.filter(item => {
        return item.id != res.data.id
      })
      dispatch(
        setStudyHallData({
          practices
        })
      )
    })
  }
}
export const updatePractice = updatedParams => {
  return (dispatch, getState) => {
    dispatch(
      setStudyHallData({
        isStudyHallUpdating: true
      })
    )
    let practices = getState().studyHall.practices
    let params = {
      lesson_activity_id: 0,
      node_id: "",
      quiz_id: "",
      answer_id: "",
      is_correct: 0,
      date_time: 0
    }
    params = Object.assign({}, params, updatedParams)

    axios
      .patch("/study-hall/practice", params)
      .then(res => {
        practices = [...practices]
        let isUpdated = false
        practices.forEach((item, idx) => {
          if (item.id === res.data.id) {
            practices[idx] = res.data
            isUpdated = true
          }
        })
        if (!isUpdated) {
          practices.push(res.data)
        }
        dispatch(
          setStudyHallData({
            practices,
            isStudyHallUpdating: false,
            error: null
          })
        )
      })
      .catch(err => {
        console.log(err)
        dispatch(
          setStudyHallData({
            error: err,
            isStudyHallUpdating: false
          })
        )
      })
  }
}

const fetchQuestionData = (collection, id) => {
  return db
    .collection(collection)
    .doc(id)
    .get()
    .then(snap => {
      return snap.data()
    })
}

export const fetchLessonItemBank = itemBankId => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        isFetchedItemBank: false
      })
    )
    fetchQuestionData("itemBanks", itemBankId).then(data => {
      dispatch(
        setStudyHallData({
          isFetchedItemBank: true,
          itemBanks: {
            [itemBankId]: data
          }
        })
      )
    })
  }
}

export const fetchQuestionItem = itemIds => {
  return async (dispatch, getState) => {
    const state = getState()

    let questionItems = state.studyHall.questionItems
    let passages = state.studyHall.passages

    try {
      const questionItemsPromises = itemIds.map(itemId =>
        fetchQuestionData("items", itemId)
      )
      const newQuestionItems = await Promise.all(questionItemsPromises)

      const filteredQuestionItems = newQuestionItems.filter(
        item => !item?.deleted
      )

      if (!!filteredQuestionItems?.length) {
        const newQuestionItemsObject = newQuestionItems.reduce(
          (res, item) => ({
            ...res,
            [item.id]: item
          }),
          {}
        )

        questionItems = {
          ...questionItems,
          ...newQuestionItemsObject
        }

        const newQuestionWithPassage = newQuestionItems.filter(
          item => !!item.passage
        )

        if (!!newQuestionWithPassage?.length) {
          const newQuestionPassagesPromises = newQuestionWithPassage.map(item =>
            db.collection("passages").doc(item.passage).get()
          )
          const newQuestionPassagesDocs = await Promise.all(
            newQuestionPassagesPromises
          )
          const newQuestionPassages = newQuestionPassagesDocs
            .filter(passageDoc => passageDoc.exists)
            .map(passageDoc => passageDoc.data())

          const newQuestionPassagesObject = newQuestionPassages.reduce(
            (res, passage) => ({
              ...res,
              [passage.id]: passage
            }),
            {}
          )

          passages = {
            ...passages,
            ...newQuestionPassagesObject
          }
        }

        dispatch(
          setStudyHallData({
            isFetchedQuestionItems: true,
            questionItems,
            passages
          })
        )
      }
    } catch (err) {}
  }
}

export const getStudentVideosWatchedStatus = (student_id, schoolYear) => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        isStudentVideoStatsFetched: false,
        videoStats: {}
      })
    )
    return db
      .collection("studyHallVideoStats")
      .doc(`${student_id}-${schoolYear}`)
      .onSnapshot(
        sn => {
          dispatch(
            setStudyHallData({
              isStudentVideoStatsFetched: true,
              videoStats: sn.data()
            })
          )
        },
        err => {
          dispatch(
            setStudyHallData({
              isStudentVideoStatsFetched: false,
              studentVideoStateError: err.message
            })
          )
        }
      )
  }
}
export const getAllVideoWatched = (filters = {}, user) => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        isFetchingAllVideoStats: true,
        allVideoStats: {}
      })
    )

    const schoolYear = Number(getSchoolYear().year)

    let query = db
      .collection("studyHallVideoStats")
      .where("schoolYear", "==", filters.y ? Number(filters.y) : schoolYear)

    const districtId = filters.district || user.schoolDistrict
    const schoolId = filters.school || user.school
    const teacherId =
      filters.teacher || (user.role === Roles.Teacher ? user.id : "")
    const classId = filters.class

    if (districtId) {
      query = query.where("schoolDistrict", "==", districtId)
    }

    if (schoolId) {
      query = query.where("school", "==", schoolId)
    }

    //Disabled below because of an edge case:
    // if a teacher creates a new class and assignes students who already have study hall data,
    //since we are not updating refs in postgress db, the scores wont show up

    // if (teacherId) {
    //   query = query.where(`teachers.${teacherId}`, "==", true)
    // }

    // if (classId) {
    //   query = query.where(`classes.${classId}`, "==", true)
    // }

    if (districtId || schoolId || teacherId || classId) {
      query.get().then(sn => {
        let payload = {}
        sn.docs.forEach(doc => {
          const data = doc.data()

          if (data && !data.deleted) {
            payload[doc.id] = data.videos
          }
        })
        return dispatch(
          setStudyHallData({
            allVideoStats: payload,
            isFetchingAllVideoStats: false
          })
        )
      })
    }
  }
}

export const inTestLessonName = lessonName => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        inTestCurrentLesson: lessonName
      })
    )
  }
}

export const updateVideoWatched = (student, videos) => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        isStudentVideoStatsFetched: false
      })
    )
    const { schoolDistrict, school, teachers = {}, classes = {}, id } = student
    const schoolYear = Number(getSchoolYear().year)
    const docId = `${id}-${schoolYear}`

    db.collection("studyHallVideoStats")
      .doc(docId)
      .set(
        {
          schoolDistrict,
          school,
          teachers,
          classes,
          id: docId,
          studentId: id,
          videos,
          schoolYear
        },
        { merge: true }
      )
      .then(res => {
        return dispatch(
          setStudyHallData({
            isStudentVideoStatsFetched: true
          })
        )
      })
      .catch(e => {
        dispatch(
          setStudyHallData({
            isStudyHallUpdating: false,
            isStudentVideoStatsFetched: false,
            error: e
          })
        )
      })
  }
}

export const updateVideoWatchedOnComplete = (schoolYear, student, videos) => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        isStudentVideoStatsFetched: true,
        isStudyHallUpdating: true
      })
    )

    const { schoolDistrict, school, teachers = {}, classes = {}, id } = student
    const docId = `${id}-${schoolYear}`

    db.collection("studyHallVideoStats")
      .doc(docId)
      .set(
        {
          schoolDistrict,
          school,
          teachers,
          classes,
          id: docId,
          studentId: id,
          videos,
          schoolYear
        },
        { merge: true }
      )
      .then(res => {
        return dispatch(
          setStudyHallData({
            isStudyHallUpdating: false,
            isStudentVideoStatsFetched: false
          })
        )
      })
      .catch(e => {
        dispatch(
          setStudyHallData({
            isStudyHallUpdating: false,
            isStudentVideoStatsFetched: false,
            error: e
          })
        )
      })
  }
}

export const setURLParams = params => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        urlParams: params
      })
    )
  }
}
export const fetchAllLessons = subCoursesKeys => {
  return (dispatch, getState) => {
    let subCourses = []
    subCoursesKeys.forEach(item => {
      subCourses.push(getLessonBySubCourseId(item))
    })
    if (subCourses.length) {
      dispatch(
        setStudyHallData({
          allLessonsFetching: true,
          allLessonsFetched: false
        })
      )
      Promise.all(subCourses)
        .then(lessons => {
          const sHallSubCourses = getState().studyHall.subCourses
          let studyHallLessons = {}
          sHallSubCourses.forEach(course => {
            let subCourseLessons = lessons.find(less => {
              return less[0].subcourseId === course.id
            })
            if (subCourseLessons) {
              studyHallLessons[course.name] = subCourseLessons
            }
          })
          dispatch(
            setStudyHallData({
              studyHallLessons,
              allLessonsFetching: false,
              allLessonsFetched: true
            })
          )
        })
        .catch(_ => {
          dispatch(
            setStudyHallData({
              allLessonsFetching: false,
              allLessonsFetched: false,
              allLessonsFetchedError: true
            })
          )
        })
    }
  }
}
export const storeActiveLesson = lesson => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        activeLesson: lesson
      })
    )
  }
}
export const setStudyHallData = payload => {
  return {
    type: STUDY_HALL_MODIFY,
    payload
  }
}
export const clearOnUpdateLessonActivityError = () => {
  return dispatch => {
    dispatch(
      setStudyHallData({
        onUpdateActivityErrorMessage: ""
      })
    )
  }
}
